import { createContext } from 'react';

export type scrollBarContextProps = {
    containerElement: HTMLElement | null;
};

export const scrollBarContext = createContext<scrollBarContextProps>({ containerElement: null });
